import { render } from "./GlobalMessenger.vue?vue&type=template&id=6455851a&scoped=true"
import script from "./GlobalMessenger.vue?vue&type=script&lang=js"
export * from "./GlobalMessenger.vue?vue&type=script&lang=js"

import "./GlobalMessenger.vue?vue&type=style&index=0&id=6455851a&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6455851a"]])

export default __exports__